<template>
  <div class="footer">
    <!-- <ul>
      <li>
        <h4>海外商务合作</h4>
        <p>手机：15311771121</p>
        <p>邮箱：trustap@trustap.vip</p>
      </li>
      <li align="center">
        <img src="../assets/wx.png" alt="" />
        <p>联系二维码</p>
      </li>
      <li>
        <h4>Trustap</h4>
        <p>公司介绍</p>
        <p>专注海外媒体广告投放，为广告主提供一站式服务。</p>
      </li>
    </ul> -->
    <div class="wrap">
      <div class="box">
        <h3>YUBARI（上海）実業有限会社</h3>
        <p>
          〒201800 上海市嘉定区江橋鎮京威大道88号9号ビル
        </p>
        <p>
          TEL：021-39527133
        </p>
        <p>
          E-mail：m-yu@yubari.cn &nbsp;&nbsp; y-tu@yubari.com
        </p>
        <p>YUBARI（上海）実業有限会社</p>
        <p>
          関连リンク:
          <a href="http://www.nbxrui.com" target="blank">祥瑞磁材</a>
        </p>
      </div>
      <div class="form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="66px"
          class="demo-ruleForm"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="ruleForm.name" placeholder="姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Email" prop="email">
                <el-input
                  v-model="ruleForm.email"
                  placeholder="メールアドレス"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="連絡先" prop="phonenum">
                <el-input
                  v-model="ruleForm.phonenum"
                  placeholder="連絡先"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="内容" prop="desc">
                <el-input
                  type="textarea"
                  v-model="ruleForm.desc"
                  placeholder="問い合わせ内容"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')"
                  >送信</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="text">
      <p>
        届出番号：<a href="https://beian.miit.gov.cn" target="blank"
          >沪ICP备2022004308号</a
        >
      </p>
    </div>
  </div>
</template>
<script>
import { addMessage } from '../api/index'

export default {
  name: 'Footer',
  components: {},
  data() {
    return {
      ruleForm: {
        name: '',
        email: '',
        phonenum: '',
        desc: '',
      },
      rules: {
        name: [
          { required: true, message: '入力してください', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '入力してください', trigger: 'blur' },
          {
            type: 'email',
            message: 'フォーマットエラー',
            trigger: ['blur', 'change'],
          },
        ],
        phonenum: {
          required: true,
          message: '入力してください',
          trigger: 'blur',
        },
        desc: { required: true, message: '入力してください', trigger: 'blur' },
      },
    }
  },
  methods: {
    jup() {
      this.$router.push('/contactus')
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addMessage(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: '送信済み',
                type: 'success',
                center: true,
                offset: 480,
              })
              this.ruleForm.name = ''
              this.ruleForm.email = ''
              this.ruleForm.phonenum = ''
              this.ruleForm.desc = ''
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 316px;
  background: #19338b;
  position: relative;

  ul {
    width: 1200px;
    margin: auto;
    // background: #a3d9ff;
    display: flex;
    padding-top: 26px;
    // color: #fff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    li {
      flex: 1;
      // background: lavender;
      margin: 10px;
      h4 {
        color: #fff;
        margin-left: 10px;
      }
      p {
        margin: 10px;
        color: rgba(255, 255, 255, 0.6);
      }
      img {
        width: 100px;
      }
    }
    li:nth-child(2) {
      border-left: 1px solid #888;
      border-right: 1px solid #888;
    }
  }
  .wrap {
    display: flex;
    justify-content: space-around;
    padding-bottom: 12px;
    border-bottom: 1px solid #aaa;
  }
  .box {
    width: 500px;
    padding-top: 26px;
    text-align: center;
    // margin: auto;
    color: #ffffff;
    line-height: 2;
    h3 {
      margin-bottom: 6px;
    }
    a {
      color: #fff;
    }
  }
  .form {
    width: 50%;
    padding-top: 26px;
  }
  /deep/.el-form-item__label {
    color: #fff;
  }
  .text {
    height: 70px;
    line-height: 70px;
    color: #fff;
    text-align: center;
    a {
      color: #fff;
    }
  }
  // .us {
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  //   bottom: 0;
  //   left: 0;
  //   margin: auto;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   background: #a3d9ff;
  //   .logo {
  //     width: 100px;
  //     img {
  //       width: 100%;
  //     }
  //   }
  //   .infor {
  //     font-size: 16px;
  //     font-family: Microsoft YaHei;
  //     font-weight: 400;
  //     color: #a3d9ff;
  //     line-height: 2;
  //     opacity: 0.7;
  //   }
  //   .but {
  //     width: 125px;
  //     height: 34px;
  //     border: 1px solid #3baeff;
  //     border-radius: 17px;
  //     text-align: center;
  //     line-height: 32px;
  //     font-family: Microsoft YaHei;
  //     font-weight: 400;
  //     color: #3baeff;
  //     opacity: 0.7;
  //     margin-left: 58px;
  //     cursor: pointer;
  //   }
  // }
}
</style>
